module.exports = __webpack_public_path__ + "img/logo_verde.2efbfbb3.svg";